import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { db, storage } from "../firebase";
import {
  collection,
  addDoc,
  onSnapshot,
  serverTimestamp,
  orderBy,
  query,
  where,
  doc,
  updateDoc,
  getDoc,
  getDocs,
  limit,
  deleteDoc,
  setDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {
  Box,
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Avatar,
  IconButton,
  CircularProgress,
  Alert,
  AlertTitle,
  Modal,
  Badge,
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Divider,
  Collapse,
  useMediaQuery,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import MicIcon from "@mui/icons-material/Mic";
import StopIcon from "@mui/icons-material/Stop";
import DeleteIcon from "@mui/icons-material/Delete";
import ShareIcon from "@mui/icons-material/Share";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import Settings from "@mui/icons-material/Settings"; // Importar el ícono
import axios from "axios";
import { runTransaction } from "firebase/firestore";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import BarChartIcon from "@mui/icons-material/BarChart";
import MenuIcon from "@mui/icons-material/Menu";
import HistoryIcon from "@mui/icons-material/History";
import PaymentIcon from "@mui/icons-material/Payment";
import { NotificationsNoneSharp } from "@mui/icons-material";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const MAX_MESSAGE_LENGTH = 500;
const DAILY_LIMIT = 3;
const MAX_AUDIO_SECONDS = 120;
const YOUTUBE_URL_REGEX =
  /https?:\/\/(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:[^\s]*&)?v=|shorts\/|live\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})(?:[^\s]*)?/i;

const getYouTubeVideo = (text = "") => {
  const match = text.match(YOUTUBE_URL_REGEX);
  if (!match) return null;
  return {
    id: match[1],
    url: `https://www.youtube.com/watch?v=${match[1]}`,
    thumbnail: `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`,
  };
};

const formatMessageTime = (timestamp) => {
  if (!timestamp) return "";
  const date = timestamp.toDate
    ? timestamp.toDate()
    : new Date(timestamp.seconds * 1000);
  return date.toLocaleTimeString("es-DO", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

function Chat() {
  const isMobile = useMediaQuery("(max-width:600px)", { noSsr: true });
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [dailyMessageCount, setDailyMessageCount] = useState(0);
  const [isChatDisabled, setIsChatDisabled] = useState(false);
  const [role, setRole] = useState("normal");
  const [randomNumbers, setRandomNumbers] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [isSendingAudio, setIsSendingAudio] = useState(false);
  const [recordingSeconds, setRecordingSeconds] = useState(0);
  const [showInfoMessage, setShowInfoMessage] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [hasNewPrediction, setHasNewPrediction] = useState(false);
  const [usersWithPredictions, setUsersWithPredictions] = useState([]); // Usuarios que publicaron predicciones
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const audioRef = useRef(null);
  const [hasNewRecharge, setHasNewRecharge] = useState(false);
  const audioNotificationRef = useRef(null);
  const recordingStreamRef = useRef(null);
  const recordingTimerRef = useRef(null);
  const recordingTimeoutRef = useRef(null);
  const recordingSecondsRef = useRef(0);
  const [coinMessage, setCoinMessage] = useState("");
  const [userCoins, setUserCoins] = useState(0);
  const [replyingTo, setReplyingTo] = useState(null);
  const [extrasOpen, setExtrasOpen] = useState(!isMobile);
  const [isSending, setIsSending] = useState(false);
  const [chatError, setChatError] = useState("");

  const username = localStorage.getItem("username");
  const avatarUrl = localStorage.getItem("avatarUrl");

  const recordingTime = `${String(Math.floor(recordingSeconds / 60)).padStart(2, "0")}:${String(recordingSeconds % 60).padStart(2, "0")}`;

  useEffect(() => {
    setExtrasOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const randomNumbersRef = doc(db, "system", "randomNumbers");
    const unsubscribe = onSnapshot(
      randomNumbersRef,
      (snapshot) => {
        if (!snapshot.exists()) return;
        setRandomNumbers((snapshot.data().numbers || []).slice(0, 3));
      },
      (error) =>
        console.error("Error al cargar los números recomendados:", error),
    );
    return unsubscribe;
  }, []);

  const simulateRecharge = () => {
    setHasNewRecharge(true);
    if (audioNotificationRef.current) {
      audioNotificationRef.current.play().catch((error) => {
        console.error("Error al reproducir el sonido:", error);
      });
    }
  };

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  useEffect(() => {
    const rechargeRef = collection(db, "recharges");

    const unsubscribe = onSnapshot(
      query(rechargeRef, where("username", "==", username)),
      (snapshot) => {
        console.log("Snapshot detectado:", snapshot.docs); // Depura el snapshot completo

        snapshot.docChanges().forEach((change) => {
          console.log("Cambio detectado:", change); // Depura los cambios individuales

          if (change.type === "added") {
            const data = change.doc.data();
            console.log("Datos de la recarga recibida:", data); // Verifica los datos recibidos

            if (data.monOro) {
              console.log("monOro detectado:", data.monOro); // Verifica si `monOro` está presente
              setHasNewRecharge(true);

              // Reproducir el sonido
              if (audioNotificationRef.current) {
                audioNotificationRef.current.play().catch((error) => {
                  console.error("Error al reproducir el sonido:", error);
                });
              }
            }
          }
        });
      },
      (error) => {
        console.error("Error al escuchar recargas:", error);
      },
    );

    return () => unsubscribe(); // Limpiar el listener al desmontar el componente
  }, [username]);

  useEffect(() => {
    if (role === "normal") {
      const interval = setInterval(() => {
        setShowModal(true);
      }, 40000); // tiempo que tarda en salir la ventana modal
      return () => clearInterval(interval);
    }
  }, [role]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleWhatsAppShare = () => {
    const message = encodeURIComponent(
      "¡Únete a nuestro chat de Loterías! Aquí está el enlace: https://chatsrd.com/",
    );
    const whatsappUrl = `https://api.whatsapp.com/send?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

  const highlightKeyword = (text) => {
    const keywords = ["PALE", "SUPER PALE", "QUINIELA", "TRIPLETA"];
    const regex = new RegExp(`\\b(${keywords.join("|")})\\b`, "gi");
    return text.replace(
      regex,
      `
      <strong style="
        font-size: 1.4em;
        background: linear-gradient(90deg, #fbc531, #f0932b, #e84118);
        -webkit-background-clip: text;
        color: transparent;
        font-family: Arial, Helvetica, sans-serif;
        font-style: italic;
        text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
        text-transform: uppercase;
        padding: 2px 4px;
      ">$1</strong>
    `,
    );
  };
  const handleClick = () => {
    navigate("/Subscribe"); // Navegar a la página de Subscribe
  };

  useEffect(() => {
    const fetchUserCoins = async () => {
      try {
        const userDocRef = doc(db, "users", username); // Asegúrate de que 'users' es el nombre correcto de la colección
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          console.log("Datos del usuario:", userData); // Depura para verificar los datos
          setUserCoins(userData.monOro || 0); // Asigna el valor de monOro o 0 si no existe
        } else {
          console.log("El documento del usuario no existe.");
        }
      } catch (error) {
        console.error("Error al obtener las monedas del usuario:", error);
      }
    };

    fetchUserCoins();
  }, [username]);

  const filterMessage = (message) => {
    const bannedWords = new Set([
      "whatsapp",
      "ws",
      "809",
      "829",
      "849",
      "dame tu contacto",
      "gmail.com",
      "outlook.com",
    ]);
    let containsProfanity = false;

    const filteredMessage = message
      .split(" ")
      .map((word) => {
        if (bannedWords.has(word.toLowerCase())) {
          containsProfanity = true;
          return "****";
        }
        return word;
      })
      .join(" ");

    if (containsProfanity) {
      setTimeout(async () => {
        await addDoc(collection(db, "messages"), {
          text: "No se permite publicar números de contactos en este chat. Favor de revisar las reglas para evitar que su cuenta se cierre",
          username: "⚠️ !AVISO!",
          avatarUrl: "",
          timestamp: serverTimestamp(),
          role: "sistema",
        });
      }, 10000);
    }

    return filteredMessage;
  };

  const scrollToBottom = () => {
    window.requestAnimationFrame(() => {
      const container = messagesContainerRef.current;
      if (!container) return;
      container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
    });
  };

  useEffect(() => {
    const predictionsRef = query(
      collection(db, "predictions"),
      orderBy("timestamp", "desc"),
    );

    const unsubscribe = onSnapshot(predictionsRef, (snapshot) => {
      const loadedPredictions = snapshot.docs.map((doc) => doc.data());
      console.log(loadedPredictions); // Depurar datos
      setUsersWithPredictions(loadedPredictions);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    // Función para publicar el mensaje del sistema
    const publishSystemMessage = async () => {
      try {
        await addDoc(collection(db, "messages"), {
          text: `🔔 Recarga tu cuenta y apoya a quienes dedican su esfuerzo para compartir sus predicciones. ¡Haz clic aquí y contribuye a su labor! <a href="https://chatsrd.com/coin-history" style="color: #1e88e5; font-weight: bold;">Recargar Cuenta</a>`,
          username: "Sistema",
          avatarUrl:
            "https://firebasestorage.googleapis.com/v0/b/otra-151ec.appspot.com/o/avatars%2Fadministrador?alt=media&token=cd23ca64-8f38-4357-8861-8f1302e19db2",
          timestamp: serverTimestamp(),
          role: "sistema",
        });
        console.log("Mensaje del sistema publicado.");
      } catch (error) {
        console.error("Error al publicar el mensaje del sistema:", error);
      }
    };

    // Publicar el mensaje cada 48 horas (48 horas = 172800000 milisegundos)
    const interval = setInterval(() => {
      publishSystemMessage();
    }, 172800000);

    // Limpiar el intervalo al desmontar el componente
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const userDocRef = doc(db, "users", username);

    const checkFirstTime = async () => {
      const userDoc = await getDoc(userDocRef);
      if (
        userDoc.exists() &&
        userDoc.data().firstTime &&
        !userDoc.data().welcomeMessageSent
      ) {
        await addDoc(collection(db, "messages"), {
          text: `🎉 ¡Hola, <strong>${username}</strong>! 🎉 
          Bienvenido/a al chat por primera vez. 🎊 
          Nos alegra mucho que estés aquí. 
          🌟 ¡Únete a la conversación y sé parte de nuestra comunidad! 🌟`,
          username: "Sistema",
          avatarUrl:
            "https://firebasestorage.googleapis.com/v0/b/otra-151ec.appspot.com/o/avatars%2Fadministrador?alt=media&token=cd23ca64-8f38-4357-8861-8f1302e19db2", // Avatar del sistema
          timestamp: serverTimestamp(),
          role: "sistema",
          style: {
            backgroundColor: "#e0f7fa", // Azul claro suave
            color: "#00796b", // Verde azulado elegante
            fontWeight: "bold",
            borderRadius: "12px", // Bordes ligeramente más redondeados
            padding: "12px", // Más espacio interno para mayor claridad
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)", // Sombra más suave y difusa
            textAlign: "center",
            border: "1px solid #80cbc4", // Borde suave en tono complementario
            fontSize: "1.1rem", // Tamaño de fuente ligeramente aumentado
          },
        });

        await updateDoc(userDocRef, {
          firstTime: false,
          welcomeMessageSent: true,
        });
      }
    };

    const fetchAvatarUrl = async () => {
      try {
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const fetchedAvatarUrl = userData.avatarUrl;
          console.log("Fetched Avatar URL:", fetchedAvatarUrl); // Depurar URL obtenida

          if (fetchedAvatarUrl) {
            localStorage.setItem("avatarUrl", fetchedAvatarUrl);
          } else {
            localStorage.removeItem("avatarUrl"); // Limpia si no existe
          }
        }
      } catch (error) {
        console.error("Error fetching avatar URL:", error);
      }
    };

    checkFirstTime();
    fetchAvatarUrl();

    updateDoc(userDocRef, { online: true });

    const unsubscribeMessages = onSnapshot(
      query(
        collection(db, "messages"),
        orderBy("timestamp", "desc"),
        limit(50),
      ),
      (snapshot) => {
        const loadedMessages = snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }));
        setMessages(loadedMessages.reverse());
        scrollToBottom();
      },
    );

    const unsubscribeUserDoc = onSnapshot(userDocRef, async (docSnap) => {
      if (docSnap.exists()) {
        const userData = docSnap.data();
        const previousRole = role;
        setRole(userData.role || "normal");

        if (userData.role === "normal") {
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const messagesQuery = query(
            collection(db, "messages"),
            where("username", "==", username),
            where("timestamp", ">=", today),
          );

          const messagesSnapshot = await getDocs(messagesQuery);
          setDailyMessageCount(messagesSnapshot.size);

          if (messagesSnapshot.size >= DAILY_LIMIT) {
            setIsChatDisabled(true);
          }
        }
      }
    });

    const handleDisconnect = () => {
      updateDoc(userDocRef, {
        online: false,
        lastOnline: serverTimestamp(),
      });
    };

    window.addEventListener("beforeunload", handleDisconnect);

    return () => {
      unsubscribeMessages();
      unsubscribeUserDoc();
      window.removeEventListener("beforeunload", handleDisconnect);
      updateDoc(userDocRef, { online: false });
    };
  }, [username, role, avatarUrl]);

  const sendMessage = async (e) => {
    e.preventDefault();

    if (isChatDisabled) {
      alert(
        "Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o Inscribete.",
      );
      return;
    }

    const text = newMessage.trim();
    if (!text || isSending) return;

    try {
      setIsSending(true);
      setChatError("");
      const userDoc = await getDoc(doc(db, "users", username));
      if (userDoc.exists() && userDoc.data().isBlocked) {
        setChatError(
          "Has sido bloqueado por un moderador y no puedes enviar mensajes.",
        );
        return;
      }

      await addDoc(collection(db, "messages"), {
        text: filterMessage(text),
        username,
        avatarUrl,
        timestamp: serverTimestamp(),
        role,
        ...(replyingTo && {
          replyTo: {
            id: replyingTo.id,
            username: replyingTo.username,
            text: replyingTo.text?.slice(0, 120) || "Contenido multimedia",
          },
        }),
      });

      setNewMessage("");
      setReplyingTo(null);
      const nextCount = dailyMessageCount + 1;
      setDailyMessageCount(nextCount);
      if (role === "normal" && nextCount >= DAILY_LIMIT)
        setIsChatDisabled(true);

      audioRef.current?.play().catch(console.error);
      scrollToBottom();
    } catch (error) {
      setChatError(`No se pudo enviar el mensaje: ${error.message}`);
    } finally {
      setIsSending(false);
    }
  };

  const handleImageUpload = async (e) => {
    if (isChatDisabled) {
      alert(
        "Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o Inscribete.",
      );
      return;
    }

    const file = e.target.files[0];
    if (file) {
      try {
        const imageRef = ref(storage, `chatImages/${username}-${Date.now()}`);
        await uploadBytes(imageRef, file);
        const imageUrl = await getDownloadURL(imageRef);

        await addDoc(collection(db, "messages"), {
          imageUrl: imageUrl,
          username: username,
          avatarUrl: avatarUrl,
          timestamp: serverTimestamp(),
          role: role,
        });

        setDailyMessageCount(dailyMessageCount + 1);

        if (role === "normal" && dailyMessageCount + 1 >= DAILY_LIMIT) {
          setIsChatDisabled(true);
          alert(
            "Has alcanzado tu límite diario de mensajes. Debes esperar 24 horas para volver a escribir o Inscribete.",
          );
        }

        scrollToBottom();
      } catch (error) {
        console.error("Error al subir la imagen: ", error);
      }
    }
  };

  const startRecording = () => {
    if (isChatDisabled || isSendingAudio) return;
    if (!navigator.mediaDevices?.getUserMedia || !window.MediaRecorder) {
      setChatError("Tu navegador no soporta la grabación de audio.");
      return;
    }

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        recordingStreamRef.current = stream;
        const preferredType = [
          "audio/webm;codecs=opus",
          "audio/webm",
          "audio/mp4",
        ].find((type) => MediaRecorder.isTypeSupported(type));
        const recorder = preferredType
          ? new MediaRecorder(stream, { mimeType: preferredType })
          : new MediaRecorder(stream);
        const recordedType = recorder.mimeType || preferredType || "audio/webm";
        const audioChunks = [];

        setMediaRecorder(recorder);
        setRecordingSeconds(0);
        recordingSecondsRef.current = 0;
        setIsRecording(true);
        recorder.start(1000);

        recordingTimerRef.current = window.setInterval(() => {
          recordingSecondsRef.current = Math.min(
            recordingSecondsRef.current + 1,
            MAX_AUDIO_SECONDS,
          );
          setRecordingSeconds(recordingSecondsRef.current);
        }, 1000);
        recordingTimeoutRef.current = window.setTimeout(() => {
          if (recorder.state === "recording") recorder.stop();
        }, MAX_AUDIO_SECONDS * 1000);

        recorder.ondataavailable = (event) => {
          if (event.data.size > 0) audioChunks.push(event.data);
        };

        recorder.onstop = async () => {
          window.clearInterval(recordingTimerRef.current);
          window.clearTimeout(recordingTimeoutRef.current);
          stream.getTracks().forEach((track) => track.stop());
          recordingStreamRef.current = null;
          setIsRecording(false);

          const audioBlob = new Blob(audioChunks, { type: recordedType });
          if (!audioBlob.size) {
            setChatError("No se detectó audio. Intenta grabar nuevamente.");
            return;
          }

          const audioExtension = recordedType.includes("mp4") ? "m4a" : "webm";
          const audioStorageRef = ref(
            storage,
            `chatAudios/${username}-${Date.now()}.${audioExtension}`,
          );
          setIsSendingAudio(true);
          try {
            await uploadBytes(audioStorageRef, audioBlob, {
              contentType: recordedType,
            });
            const audioUrl = await getDownloadURL(audioStorageRef);
            await addDoc(collection(db, "messages"), {
              audioUrl,
              audioDuration: Math.min(
                recordingSecondsRef.current || 1,
                MAX_AUDIO_SECONDS,
              ),
              username,
              avatarUrl,
              timestamp: serverTimestamp(),
              role,
            });
            const nextCount = dailyMessageCount + 1;
            setDailyMessageCount(nextCount);
            if (role === "normal" && nextCount >= DAILY_LIMIT)
              setIsChatDisabled(true);
            scrollToBottom();
          } catch (error) {
            setChatError(`No se pudo enviar la nota de voz: ${error.message}`);
          } finally {
            setIsSendingAudio(false);
            setRecordingSeconds(0);
            recordingSecondsRef.current = 0;
            setMediaRecorder(null);
          }
        };
      })
      .catch(() =>
        setChatError(
          "No se pudo acceder al micrófono. Revisa los permisos del navegador.",
        ),
      );
  };

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.stop();
    }
  };

  const handleAudioButtonClick = () => {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  useEffect(() => {
    return () => {
      window.clearInterval(recordingTimerRef.current);
      window.clearTimeout(recordingTimeoutRef.current);
      recordingStreamRef.current?.getTracks().forEach((track) => track.stop());
    };
  }, []);

  useEffect(() => {
    // Chrome puede emitir este aviso no fatal durante cambios rápidos de layout.
    // Evitamos que el overlay de desarrollo bloquee el chat, sin ocultar otros errores.
    const ignoreResizeObserverWarning = (event) => {
      if (
        event.message ===
          "ResizeObserver loop completed with undelivered notifications." ||
        event.message === "ResizeObserver loop limit exceeded"
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    };
    window.addEventListener("error", ignoreResizeObserverWarning);
    return () =>
      window.removeEventListener("error", ignoreResizeObserverWarning);
  }, []);

  const deleteMessage = async (messageId) => {
    try {
      await deleteDoc(doc(db, "messages", messageId));
      alert("Mensaje eliminado correctamente.");
    } catch (error) {
      console.error("Error al eliminar el mensaje: ", error);
      alert("Hubo un error al intentar eliminar el mensaje.");
    }
  };

  const handleShareOnWhatsApp = () => {
    const message = encodeURIComponent(
      "¡Únete a nuestro chat de Loterías! Aquí está el enlace: https://chatsrd.com/",
    );
    const whatsappUrl = `https://api.whatsapp.com/send?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

  const getMessageStyle = (msgRole, isOwn) => {
    switch (msgRole) {
      case "oro":
        return {
          background: "linear-gradient(135deg, #fff7c2, #ffd54f)",
          color: "#4a3500",
          padding: "12px 14px",
          borderRadius: isOwn ? "18px 18px 5px 18px" : "18px 18px 18px 5px",
          maxWidth: { xs: "82%", sm: "72%" },
          boxShadow: "0 6px 18px rgba(180, 125, 0, 0.18)",
          border: "1px solid #f5b700",
        };
      case "platino":
        return {
          background: "linear-gradient(135deg, #effcff, #bdefff)",
          color: "#083344",
          padding: "12px 14px",
          borderRadius: isOwn ? "18px 18px 5px 18px" : "18px 18px 18px 5px",
          maxWidth: { xs: "82%", sm: "72%" },
          boxShadow: "0 6px 18px rgba(14, 116, 144, 0.16)",
          border: "1px solid #67d5f0",
        };
      case "moderador":
        return {
          background: "linear-gradient(135deg, #15803d, #16a34a)",
          color: "#fff",
          padding: "12px 14px",
          borderRadius: isOwn ? "18px 18px 5px 18px" : "18px 18px 18px 5px",
          maxWidth: { xs: "82%", sm: "72%" },
          boxShadow: "0 6px 18px rgba(21, 128, 61, 0.20)",
          border: "1px solid rgba(255,255,255,.32)",
        };
      case "sistema":
        return {
          background: "linear-gradient(135deg, #fff7ed, #ffedd5)",
          color: "#9a3412",
          padding: "11px 14px",
          borderRadius: "14px",
          maxWidth: { xs: "90%", sm: "78%" },
          border: "1px solid #fdba74",
          boxShadow: "0 5px 14px rgba(154,52,18,.10)",
        };
      case "normal":
      default:
        return {
          background: isOwn
            ? "linear-gradient(135deg, #2563eb, #1d4ed8)"
            : "linear-gradient(145deg, #ffffff, #f8fafc)",
          color: isOwn ? "#fff" : "#172033",
          padding: "11px 14px",
          borderRadius: isOwn ? "18px 18px 5px 18px" : "18px 18px 18px 5px",
          maxWidth: { xs: "82%", sm: "72%" },
          boxShadow: isOwn
            ? "0 6px 18px rgba(37,99,235,.22)"
            : "0 5px 16px rgba(15,23,42,.09)",
          border: isOwn ? "none" : "1px solid #e2e8f0",
        };
    }
  };

  useEffect(() => {
    const API_URL =
      "https://sorteosrd.com/api/sorteosrd-results/217XUR6ivy8A1NdI4SKcnAa9YGZRV7w3k";

    const specificLotteries = [
      "Florida Lottery 1:30 PM",
      "Florida 10:50 PM",
      "King Lottery 12:30 PM",
      "King Lottery 7:30 PM",
      "New York Lottery 3:30 PM",
      "New York Lottery 10:30 PM",
    ];

    const otherLotteries = [
      "Loto Real 12:55 PM",
      "La Suerte Dominicana 12:30PM",
      "La Suerte 6:00 PM",
      "La Primera 12:00PM",
      "La Primera 8:00 PM",
      "Quiniela Loteka 7:55 PM",
      "Quiniela LoteDom 5:55 PM",
      "Anguila 10:00 AM",
      "Anguila 1:00 PM",
      "Anguila 6:00 PM",
      "Anguila 9:00 PM",
      "Loteria Nacional 2:30 PM Gana Más",
    ];

    const allRelevantLotteries = [...specificLotteries, ...otherLotteries];

    const getCurrentDate = () => new Date().toISOString().split("T")[0];

    const processLotteryNumbers = (description, num1, num2, num3) => {
      if (specificLotteries.includes(description)) {
        return [
          parseInt(num1.toString().slice(1)),
          parseInt(num2.toString().slice(-2)),
          parseInt(num3.toString().slice(-2)),
        ];
      }
      return [parseInt(num1), parseInt(num2), parseInt(num3)];
    };

    const fetchAndProcessAciertos = async () => {
      try {
        const currentDate = getCurrentDate();

        // Obtener resultados de la API
        const apiResponse = await axios.get(API_URL);
        const apiResults = apiResponse.data
          .filter(
            (result) =>
              allRelevantLotteries.includes(result.descripcion) &&
              new Date(result.created_at).toISOString().split("T")[0] ===
                currentDate,
          )
          .map((result) => ({
            description: result.descripcion,
            lotteryNumbers: processLotteryNumbers(
              result.descripcion,
              result.num1,
              result.num2,
              result.num3,
            ),
          }));

        // Obtener predicciones
        const predictionsSnapshot = await getDocs(
          collection(db, "predictions"),
        );
        const predictions = predictionsSnapshot.docs.map((doc) => ({
          username: doc.data().username,
          numbers: doc.data().numbers.split("-").map(Number),
        }));

        // Obtener claves únicas notificadas desde Firestore
        const notifiedSnapshot = await getDocs(collection(db, "notifiedKeys"));
        const notifiedKeys = notifiedSnapshot.docs.map((doc) => doc.id);

        const nuevosAciertos = [];
        predictions.forEach((prediction) => {
          prediction.numbers.forEach((num) => {
            apiResults.forEach((result) => {
              const lotteryNumbers = result.lotteryNumbers;

              if (lotteryNumbers.includes(num)) {
                const premio =
                  lotteryNumbers.indexOf(num) === 0
                    ? "En Primera"
                    : lotteryNumbers.indexOf(num) === 1
                      ? "En Segunda"
                      : "En Tercera";

                const uniqueKey = `${prediction.username}-${num}-${result.description}`;
                if (!notifiedKeys.includes(uniqueKey)) {
                  nuevosAciertos.push({
                    uniqueKey,
                    username: prediction.username,
                    text: `🎉 ¡Felicidades ${prediction.username}! Has acertado con el número ${num} en ${premio} en la ${result.description}. 🎊`,
                  });
                }
              }
            });
          });
        });

        // Enviar mensajes y registrar notificaciones
        const batch = nuevosAciertos.map(async (acierto) => {
          await addDoc(collection(db, "messages"), {
            text: acierto.text,
            username: "Sistema",
            avatarUrl:
              "https://firebasestorage.googleapis.com/v0/b/otra-151ec.appspot.com/o/avatars%2Fadministrador?alt=media&token=cd23ca64-8f38-4357-8861-8f1302e19db2",
            timestamp: serverTimestamp(),
            role: "sistema",
          });

          await setDoc(doc(db, "notifiedKeys", acierto.uniqueKey), {
            timestamp: serverTimestamp(),
          });
        });

        await Promise.all(batch);
      } catch (error) {
        console.error("Error al procesar aciertos:", error.message);
      }
    };

    const unsubscribe = onSnapshot(
      collection(db, "predictions"),
      (snapshot) => {
        if (!snapshot.empty) {
          fetchAndProcessAciertos();
        }
      },
    );

    return unsubscribe;
  }, []);

  const handlePredictionsClick = () => {
    // Solo permitir acceso a los roles 'oro' y 'platino'
    if (["oro", "platino", "moderador"].includes(role)) {
      setHasNewPrediction(false);
      navigate("/predictions");
    } else {
      // Mostrar alerta para roles no permitidos
      alert(
        "🚫 Solo los miembros Oro y Platino tienen acceso a las predicciones. ¡Hazte miembro para acceder!",
      );
    }
  };

  return (
    <Container maxWidth="lg" disableGutters={{ xs: true, sm: false }}>
      <Box
        sx={{
          mt: { xs: 0, sm: 2 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          minHeight: { xs: "100dvh", sm: "auto" },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            position: "relative",
            overflow: "hidden",
            borderRadius: { xs: 0, sm: "18px" },
            bgcolor: "#fff",
            boxShadow: "0 14px 42px rgba(15, 23, 42, 0.14)",
          }}
        >
          <IconButton
            component={Link}
            to="/settings"
            sx={{
              position: "absolute",
              top: { xs: 8, sm: 12 },
              right: { xs: 8, sm: 12 },
              bgcolor: "rgba(255, 255, 255, 0.1)", // Fondo translúcido
              borderRadius: "50%",
              padding: { xs: "8px", sm: "10px" },
              "&:hover": {
                bgcolor: "rgba(255, 255, 255, 0.2)", // Hover más visible
              },
              transition: "background-color 0.3s ease",
            }}
          >
            <Settings sx={{ fontSize: "30px", color: "white" }} />{" "}
            {/* Ícono blanco */}
          </IconButton>

          <Typography
            variant="h4"
            gutterBottom
            sx={{
              padding: { xs: "16px 54px 16px 16px", sm: "20px 60px" },
              background:
                "linear-gradient(120deg, #172554 0%, #2563eb 62%, #06b6d4 125%)",
              color: "white",
              textAlign: "center",
              borderRadius: 0,
              boxShadow: "0 7px 20px rgba(37, 99, 235, 0.22)",
              fontWeight: "bold",
              fontSize: { xs: "1.35rem", sm: "1.8rem" },
              mb: 0,
            }}
          >
            Bienvenido, {username}
          </Typography>

          <Box
            sx={{
              textAlign: "center",
              mb: 0,
              display: "flex", // Alinear horizontalmente
              flexWrap: "wrap", // Permitir que los botones se ajusten en varias filas
              justifyContent: "center", // Centrar los botones
              gap: 0,
            }}
          >
            <Box sx={{ mb: 0, width: "100%" }}>
              <AppBar
                position="static"
                elevation={0}
                sx={{
                  background: "linear-gradient(90deg, #0f4fa8, #1976d2)",
                  borderBottom: "1px solid rgba(255,255,255,.16)",
                }}
              >
                <Toolbar
                  sx={{
                    justifyContent: "space-between",
                    minHeight: { xs: 58, md: 70 },
                    px: { xs: 1, md: 2 },
                  }}
                >
                  {/* Botón de menú para pantallas pequeñas */}
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ display: { xs: "flex", md: "none" } }}
                    onClick={toggleDrawer(true)}
                  >
                    <MenuIcon />
                  </IconButton>

                  {/* Título o logo */}
                  <Typography
                    variant="h6"
                    sx={{
                      flexGrow: 1,
                      fontWeight: 800,
                      fontSize: { xs: "1rem", md: "1.15rem" },
                    }}
                  >
                    Menú
                  </Typography>

                  {/* Botones de navegación para pantallas grandes */}
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      gap: 0.5,
                      alignItems: "center",
                    }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<PaymentIcon />}
                      onClick={handleClick}
                      sx={{
                        backgroundColor: "#ff9800",
                        color: "white",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        borderRadius: "8px",
                        px: 1.5,
                        boxShadow: "0 5px 14px rgba(245,124,0,.28)",
                        "&:hover": {
                          backgroundColor: "#f57c00",
                        },
                      }}
                    >
                      Recarga tu cuenta
                    </Button>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mx: 1,
                        px: 1.25,
                        py: 0.75,
                        borderRadius: 3,
                        bgcolor: "rgba(255,255,255,.12)",
                      }}
                    >
                      <MonetizationOnIcon sx={{ color: "gold", mr: 1 }} />
                      <Typography
                        variant="body1"
                        sx={{ color: "white", fontWeight: "bold" }}
                      >
                        {userCoins} Monedas
                      </Typography>
                    </Box>

                    <Button
                      color="inherit"
                      component={Link}
                      to="/historial-chat"
                      startIcon={<HistoryIcon />}
                      sx={{ borderRadius: 3, px: 1.25 }}
                    >
                      Historial de Mensajes
                    </Button>

                    <Button
                      color="inherit"
                      component={Link}
                      to="/ConnectedUsers"
                      startIcon={<NotificationsNoneSharp />}
                      sx={{ borderRadius: 3, px: 1.25 }}
                    >
                      Usuarios en linea
                    </Button>

                    <Button
                      color="inherit"
                      onClick={handlePredictionsClick}
                      startIcon={<NotificationsActiveIcon />}
                      sx={{ borderRadius: 3, px: 1.25 }}
                    >
                      Predicciones
                    </Button>

                    <Button
                      color="inherit"
                      component={Link}
                      to="/WeeklyStatistics"
                      startIcon={<BarChartIcon />}
                      sx={{ borderRadius: 3, px: 1.25 }}
                    >
                      Estadísticas
                    </Button>
                  </Box>
                </Toolbar>
              </AppBar>

              {/* Drawer para pantallas pequeñas */}
              <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                  sx: {
                    background: "linear-gradient(180deg, #eff6ff, #fff)",
                    width: 286,
                  },
                }}
              >
                <Box
                  sx={{ width: 286 }}
                  role="presentation"
                  onClick={toggleDrawer(false)}
                >
                  <Box
                    sx={{
                      p: 2.25,
                      color: "white",
                      background: "linear-gradient(135deg, #172554, #2563eb)",
                    }}
                  >
                    <Typography variant="h6" fontWeight={900}>
                      Chat SRD
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.84 }}>
                      {username} · {userCoins} monedas
                    </Typography>
                  </Box>
                  <Divider />
                  <List>
                    <ListItem button onClick={handleClick}>
                      <ListItemIcon>
                        <PaymentIcon />
                      </ListItemIcon>
                      <ListItemText primary="Recarga tu cuenta" />
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <MonetizationOnIcon sx={{ color: "gold" }} />
                      </ListItemIcon>
                      <ListItemText primary={`${userCoins} Monedas`} />
                    </ListItem>

                    <ListItem button component={Link} to="/historial-chat">
                      <ListItemIcon>
                        <HistoryIcon />
                      </ListItemIcon>
                      <ListItemText primary="Historial de Mensajes" />
                    </ListItem>

                    <ListItem button onClick={handlePredictionsClick}>
                      <ListItemIcon>
                        <NotificationsActiveIcon />
                      </ListItemIcon>
                      <ListItemText primary="Predicciones" />
                    </ListItem>

                    <ListItem button component={Link} to="/WeeklyStatistics">
                      <ListItemIcon>
                        <BarChartIcon />
                      </ListItemIcon>
                      <ListItemText primary="Estadísticas" />
                    </ListItem>

                    <ListItem button component={Link} to="/ConnectedUsers">
                      <ListItemIcon>
                        <NotificationsNoneSharp />
                      </ListItemIcon>
                      <ListItemText primary="Usuarios en Linea" />
                    </ListItem>
                  </List>
                </Box>
              </Drawer>
            </Box>

            <Box
              sx={{
                width: "100%",
                px: { xs: 1.5, sm: 2.5 },
                py: { xs: 1.4, sm: 1.8 },
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                justifyContent: "center",
                gap: { xs: 1, sm: 2 },
                background: "linear-gradient(135deg, #fffbeb, #ffffff)",
                borderBottom: "1px solid #fde68a",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ color: "#765800", fontWeight: 900 }}
              >
                NÚMEROS RECOMENDADOS DEL DÍA
              </Typography>
              <Box sx={{ display: "flex", gap: { xs: 1, sm: 1.5 } }}>
                {[0, 1, 2].map((index) => (
                  <Box
                    key={index}
                    sx={{
                      minWidth: { xs: 64, sm: 78 },
                      px: 1.5,
                      py: 0.8,
                      borderRadius: 3,
                      color: "#614700",
                      fontSize: { xs: "1.35rem", sm: "1.55rem" },
                      fontWeight: 900,
                      letterSpacing: 1,
                      background: "linear-gradient(145deg, #fff3b0, #ffd66b)",
                      border: "2px solid #ffd070",
                      boxShadow: "0 5px 14px rgba(217, 153, 0, .18)",
                    }}
                  >
                    {randomNumbers[index] ?? "--"}
                  </Box>
                ))}
              </Box>
            </Box>

            <motion.div
              animate={{
                opacity: [1, 0.5, 1],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              style={{
                width: "100%", // Asegura el tamaño correcto al usar motion.div
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Badge
                color="error"
                variant="dot"
                invisible={!hasNewPrediction}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              ></Badge>
            </motion.div>
          </Box>
          <Box
            sx={{
              position: "fixed",
              top: { xs: 72, sm: 20 },
              right: { xs: 10, sm: 20 },
              left: { xs: 10, sm: "auto" },
              zIndex: 1400,
            }}
          >
            {hasNewRecharge && (
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  setHasNewRecharge(false);
                  window.open("https://chatsrd.com/coin-history", "_blank");
                }}
                sx={{
                  borderRadius: 3,
                  boxShadow: "0 8px 24px rgba(22,163,74,.28)",
                }}
              >
                🎉 ¡Recibiste monedas! Haz clic para ver el historial
              </Button>
            )}
          </Box>

          {chatError && (
            <Alert
              severity="error"
              onClose={() => setChatError("")}
              sx={{ borderRadius: 0 }}
            >
              {chatError}
            </Alert>
          )}

          <Paper
            ref={messagesContainerRef}
            elevation={0}
            sx={{
              p: { xs: 1.25, sm: 2 },
              mb: 0,
              height: { xs: "calc(100dvh - 225px)", md: "68vh" },
              minHeight: 420,
              overflowY: "auto",
              borderRadius: 0,
              background:
                "radial-gradient(circle at 12% 8%, rgba(14,165,233,.10), transparent 26%), radial-gradient(circle at 88% 82%, rgba(99,102,241,.09), transparent 28%), #f1f5f9",
            }}
          >
            {messages.length === 0 && (
              <Typography
                color="text.secondary"
                textAlign="center"
                sx={{ mt: 6 }}
              >
                No encontramos mensajes.
              </Typography>
            )}
            {messages.map(({ id, data }) => {
              const isOwn = data.username === username;
              const youtubeVideo = getYouTubeVideo(data.text);
              return (
                <motion.div
                  key={id}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.22 }}
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    marginBottom: "14px",
                    flexDirection: isOwn ? "row-reverse" : "row",
                  }}
                >
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Avatar
                      src={data.avatarUrl}
                      sx={{
                        width: { xs: 34, sm: 40 },
                        height: { xs: 34, sm: 40 },
                        ml: isOwn ? 1 : 0,
                        mr: !isOwn ? 1 : 0,
                        boxShadow: "0 3px 10px rgba(15,23,42,.16)",
                      }}
                    />

                    {data.role === "moderador" && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "green",
                          fontSize: "0.74rem",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        Moderador
                      </Typography>
                    )}
                    {data.role === "oro" && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "gold",
                          fontSize: "0.74rem",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        ORO
                      </Typography>
                    )}
                    {data.role === "platino" && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "lightblue",
                          fontSize: "0.74rem",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        Platino
                      </Typography>
                    )}
                    {data.role === "normal" && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "black",
                          fontSize: "0.74rem",
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        Invitado
                      </Typography>
                    )}
                  </motion.div>

                  <Paper
                    sx={{
                      ...getMessageStyle(data.role, isOwn),
                      textAlign: "left",
                      position: "relative",
                      marginLeft: !isOwn ? "4px" : "0",
                      marginRight: isOwn ? "4px" : "0",
                    }}
                  >
                    <Typography variant="subtitle1">
                      <strong>
                        {data.role === "platino" && "⭐"} {data.username}
                      </strong>
                    </Typography>
                    {data.text && (
                      <Typography
                        variant="body1"
                        dangerouslySetInnerHTML={{
                          __html: highlightKeyword(data.text),
                        }}
                      />
                    )}
                    {data.replyTo && (
                      <Box
                        sx={{
                          mb: 1,
                          p: 0.8,
                          borderLeft: "3px solid currentColor",
                          borderRadius: 1,
                          bgcolor: "rgba(255,255,255,.22)",
                        }}
                      >
                        <Typography variant="caption" fontWeight={900}>
                          {data.replyTo.username}
                        </Typography>
                        <Typography variant="caption" display="block" noWrap>
                          {data.replyTo.text}
                        </Typography>
                      </Box>
                    )}
                    {youtubeVideo && (
                      <Box
                        component="a"
                        href={youtubeVideo.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          display: "block",
                          mt: 1.25,
                          width: "min(420px, 68vw)",
                          maxWidth: "100%",
                          overflow: "hidden",
                          borderRadius: 2.5,
                          bgcolor: "#0f172a",
                          color: "#fff",
                          textDecoration: "none",
                          boxShadow: "0 8px 22px rgba(15,23,42,.24)",
                          transition: "transform .18s ease",
                          "&:hover": { transform: "translateY(-2px)" },
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            aspectRatio: "16 / 9",
                            overflow: "hidden",
                          }}
                        >
                          <Box
                            component="img"
                            src={youtubeVideo.thumbnail}
                            alt="Miniatura del video de YouTube"
                            loading="lazy"
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              inset: 0,
                              display: "grid",
                              placeItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                width: 58,
                                height: 40,
                                borderRadius: 2,
                                bgcolor: "#ff0033",
                                display: "grid",
                                placeItems: "center",
                                boxShadow: "0 4px 14px rgba(0,0,0,.35)",
                                "&::after": {
                                  content: '\"\"',
                                  width: 0,
                                  height: 0,
                                  borderTop: "9px solid transparent",
                                  borderBottom: "9px solid transparent",
                                  borderLeft: "15px solid white",
                                  ml: 0.5,
                                },
                              }}
                            />
                          </Box>
                        </Box>
                        <Typography
                          variant="body2"
                          fontWeight={800}
                          sx={{ px: 1.25, py: 1 }}
                        >
                          YouTube · Toca para reproducir
                        </Typography>
                      </Box>
                    )}
                    {data.imageUrl && (
                      <Box sx={{ mt: 2 }}>
                        <img
                          src={data.imageUrl}
                          alt="Shared content"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            maxHeight: "300px",
                            borderRadius: "8px",
                          }}
                        />
                      </Box>
                    )}
                    {data.audioUrl && (
                      <Box sx={{ mt: 2 }}>
                        <audio
                          controls
                          preload="metadata"
                          src={data.audioUrl}
                          style={{ width: "min(270px, 64vw)" }}
                        >
                          Tu navegador no permite reproducir este audio.
                        </audio>
                      </Box>
                    )}
                    <Typography variant="caption" sx={{ fontStyle: "italic" }}>
                      {formatMessageTime(data.timestamp)}
                    </Typography>
                    <Tooltip title="Responder">
                      <IconButton
                        size="small"
                        onClick={() =>
                          setReplyingTo({
                            id,
                            username: data.username,
                            text: data.text,
                          })
                        }
                        sx={{
                          position: "absolute",
                          top: "50%",
                          transform: "translateY(-50%)",
                          ...(isOwn ? { left: -38 } : { right: -38 }),
                          bgcolor: "rgba(255,255,255,.82)",
                          boxShadow: 1,
                          "&:hover": { bgcolor: "#fff" },
                        }}
                      >
                        <ReplyRoundedIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    {role === "moderador" && (
                      <IconButton
                        sx={{ position: "absolute", top: 0, right: 0 }}
                        onClick={() => deleteMessage(id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Paper>
                </motion.div>
              );
            })}
            <div ref={messagesEndRef} />
          </Paper>

          {isChatDisabled && (
            <Box sx={{ mb: 3 }}>
              <Alert severity="warning">
                Has alcanzado tu límite diario de mensajes. Debes esperar 24
                horas para volver a escribir o Inscribete.
              </Alert>
            </Box>
          )}

          {replyingTo && (
            <Box
              sx={{
                mx: { xs: 1, sm: 2 },
                mt: 1,
                p: 1,
                pl: 1.5,
                display: "flex",
                alignItems: "center",
                bgcolor: "#eff6ff",
                borderLeft: "4px solid #2563eb",
                borderRadius: 2,
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="caption" color="primary" fontWeight={900}>
                  Respondiendo a {replyingTo.username}
                </Typography>
                <Typography variant="body2" noWrap>
                  {replyingTo.text || "Contenido multimedia"}
                </Typography>
              </Box>
              <IconButton size="small" onClick={() => setReplyingTo(null)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          )}

          {isRecording && (
            <Box
              sx={{
                display: { xs: "flex", sm: "none" },
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                py: 0.75,
                color: "#b91c1c",
                bgcolor: "#fff1f2",
                borderTop: "1px solid #fecdd3",
                fontWeight: 900,
              }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: "#ef4444",
                }}
              />
              Grabando {recordingTime} / 02:00
            </Box>
          )}

          <Box
            component="form"
            onSubmit={sendMessage}
            sx={{
              display: "flex",
              alignItems: "flex-end",
              gap: { xs: 0.4, sm: 0.75 },
              p: { xs: 1, sm: 1.5 },
              background: "linear-gradient(180deg, #fff, #f8fafc)",
              borderTop: "1px solid #e2e8f0",
              position: "sticky",
              bottom: 0,
              zIndex: 3,
              boxShadow: "0 -7px 22px rgba(15,23,42,.07)",
            }}
          >
            <Box sx={{ position: "relative", flexGrow: 1, minWidth: 0 }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                id="newMessage"
                placeholder="Escribe un mensaje..."
                name="newMessage"
                autoComplete="off"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage(e);
                  }
                }}
                multiline
                rows={2}
                inputProps={{ maxLength: MAX_MESSAGE_LENGTH }}
                disabled={isChatDisabled || isSending}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    minHeight: 64,
                    borderRadius: 3.5,
                    bgcolor: "#fff",
                    pr: 1,
                    pb: 2.25,
                    "& fieldset": { borderColor: "#cbd5e1" },
                    "&:hover fieldset": { borderColor: "#60a5fa" },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2563eb",
                      borderWidth: 2,
                    },
                  },
                }}
              />
              {newMessage.length > 0 && (
                <Typography
                  variant="caption"
                  color={newMessage.length > 450 ? "error" : "text.secondary"}
                  sx={{
                    position: "absolute",
                    right: 13,
                    bottom: 5,
                    pointerEvents: "none",
                  }}
                >
                  {newMessage.length}/{MAX_MESSAGE_LENGTH}
                </Typography>
              )}
            </Box>
            <Tooltip title="Enviar imagen">
              <IconButton
                color="primary"
                component="label"
                disabled={isChatDisabled || isSending}
                sx={{
                  width: { xs: 40, sm: 46 },
                  height: { xs: 40, sm: 46 },
                  flexShrink: 0,
                  bgcolor: "#eff6ff",
                  "&:hover": { bgcolor: "#dbeafe" },
                }}
              >
                <PhotoCamera />
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleImageUpload}
                />
              </IconButton>
            </Tooltip>

            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {isRecording && (
                <Typography
                  variant="caption"
                  sx={{
                    display: { xs: "none", sm: "block" },
                    minWidth: 70,
                    color: "#dc2626",
                    fontWeight: 900,
                    whiteSpace: "nowrap",
                  }}
                >
                  ● {recordingTime} / 02:00
                </Typography>
              )}
              <Tooltip
                title={
                  isRecording
                    ? `Detener grabación (${recordingTime} / 02:00)`
                    : "Grabar nota de voz (máximo 2 minutos)"
                }
              >
                <IconButton
                  color={isRecording ? "error" : "primary"}
                  aria-label={
                    isRecording ? "Detener nota de voz" : "Grabar nota de voz"
                  }
                  sx={{
                    width: { xs: 40, sm: 46 },
                    height: { xs: 40, sm: 46 },
                    flexShrink: 0,
                    bgcolor: isRecording ? "#fee2e2" : "#eff6ff",
                    animation: isRecording
                      ? "recordingPulse 1.2s infinite ease-in-out"
                      : "none",
                    "@keyframes recordingPulse": {
                      "0%, 100%": { boxShadow: "0 0 0 0 rgba(220,38,38,.2)" },
                      "50%": { boxShadow: "0 0 0 7px rgba(220,38,38,.12)" },
                    },
                  }}
                  onClick={handleAudioButtonClick}
                  disabled={isChatDisabled || isSendingAudio}
                >
                  {isRecording ? <StopIcon /> : <MicIcon />}
                </IconButton>
              </Tooltip>
              {isSendingAudio && <CircularProgress size={24} />}
            </Box>

            <IconButton
              type="submit"
              aria-label="Enviar mensaje"
              sx={{
                width: { xs: 42, sm: 48 },
                height: { xs: 42, sm: 48 },
                flexShrink: 0,
                color: "#fff",
                background: "linear-gradient(135deg, #2563eb, #06b6d4)",
                boxShadow: "0 6px 15px rgba(37,99,235,.25)",
                "&:hover": {
                  background: "linear-gradient(135deg, #1d4ed8, #0891b2)",
                },
                "&.Mui-disabled": { bgcolor: "#e2e8f0", background: "#e2e8f0" },
              }}
              disabled={isChatDisabled || isSending || !newMessage.trim()}
            >
              {isSending ? <CircularProgress size={22} /> : <SendRoundedIcon />}
            </IconButton>
          </Box>

          <Button
            fullWidth
            onClick={() => setExtrasOpen((open) => !open)}
            endIcon={
              extrasOpen ? (
                <KeyboardArrowDownRoundedIcon />
              ) : (
                <KeyboardArrowUpRoundedIcon />
              )
            }
            aria-expanded={extrasOpen}
            aria-controls="chat-extra-options"
            sx={{
              minHeight: 42,
              borderRadius: 0,
              textTransform: "none",
              fontWeight: 800,
              color: "#1e3a8a",
              bgcolor: "#eff6ff",
              borderTop: "1px solid #dbeafe",
              "&:hover": { bgcolor: "#dbeafe" },
            }}
          >
            {extrasOpen ? "Ocultar opciones" : "Ver predicciones y compartir"}
          </Button>

          <Collapse in={extrasOpen} timeout={220} unmountOnExit>
            <Box
              id="chat-extra-options"
              sx={{
                p: { xs: 1.25, sm: 2 },
                bgcolor: "#f8fafc",
                borderTop: "1px solid #e2e8f0",
              }}
            >
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #dbe4ef",
                  borderRadius: "12px",
                  bgcolor: "#fff",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Predicciones actualizadas
                </Typography>
                <Box sx={{ display: "flex", gap: 2, overflowX: "auto", p: 1 }}>
                  {usersWithPredictions.map((user, index) => (
                    <Box key={index} sx={{ textAlign: "center" }}>
                      <Avatar
                        src={
                          user.imageUrl ||
                          user.avatarUrl ||
                          "https://chatsrd.com/estado-avatar.png"
                        }
                        sx={{
                          width: 40,
                          height: 40,
                          mb: 1,
                          border: "2px solid #4caf50",
                          animation: "pulseBorder 1.5s infinite ease-in-out", // Aplicar la animación
                          "@keyframes pulseBorder": {
                            "0%": { boxShadow: "0 0 0px #4caf50" },
                            "50%": { boxShadow: "0 0 10px #4caf50" },
                            "100%": { boxShadow: "0 0 0px #4caf50" },
                          },
                        }}
                      />

                      <Typography variant="body2" noWrap>
                        {user.username}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>

              {role === "normal" && showInfoMessage && (
                <Alert
                  severity="info"
                  sx={{ mt: 2, position: "relative" }}
                  action={
                    <IconButton
                      size="small"
                      aria-label="close"
                      color="inherit"
                      onClick={() => setShowInfoMessage(false)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  }
                >
                  <AlertTitle>Información</AlertTitle>
                  🟡{" "}
                  <strong>
                    Hazte miembro y podrás tener acceso a los números
                    recomendados y las mejores predicciones, el costo es de
                    RD$1500 pesos.
                  </strong>
                </Alert>
              )}

              <Box sx={{ textAlign: "center", mt: 2 }}>
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<ShareIcon />}
                  onClick={handleShareOnWhatsApp}
                  sx={{
                    fontSize: "14px",
                    padding: "6px 16px",
                    borderRadius: "8px",
                  }}
                >
                  Compartir en WhatsApp
                </Button>
              </Box>
            </Box>
          </Collapse>

          <audio ref={audioRef} src="/sounds/notification.mp3" />
        </Box>
      </Box>

      <Modal
        open={showModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          style={{
            backgroundColor: "white",
            borderRadius: "10px",
            padding: "20px",
            maxWidth: "400px",
            margin: "100px auto",
            textAlign: "center",
            position: "relative",
          }}
        >
          <IconButton
            style={{ position: "absolute", top: 10, right: 10 }}
            onClick={handleCloseModal}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" gutterBottom>
            ¡Comparte esta página!
          </Typography>
          <Typography variant="body1">
            Ayúdanos a crecer compartiendo este chat por WhatsApp para que más
            personas se unan.
          </Typography>

          <Button
            variant="contained"
            color="success"
            startIcon={<ShareIcon />}
            onClick={handleWhatsAppShare}
            style={{ marginTop: "20px" }}
          >
            Compartir en WhatsApp
          </Button>
        </motion.div>
      </Modal>
    </Container>
  );
}

export default Chat;
